module.exports = __webpack_public_path__ + "img/icon-binoculars-black.6dbbf945.svg";